import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {useSelector, useStore} from "react-redux";
import Grid from "@material-ui/core/Grid";
import CardMedia from "@material-ui/core/CardMedia";
import SentenceForm from "../components/common/SentenceForm";
import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import logoImg from "../assets/result_logo.png";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import HouseSummaryAccordion from "../components/common/HouseSummaryAccordion";
import CommercialSummaryAccordion from "../components/common/CommercialSummaryAccordion";
import {withRouter} from "react-router-dom";
import {withStyles} from "@material-ui/core";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
  agreeDataState,
  answerState, bizFileState, etcFileState, etcReturnFileState,
  familyState, intFileState, rentFileState,
  rentState,
  selectedMenuItemState, seqState, simpleFileState, surveyDataState,
  userState
} from '../state/globalState'
import {getCommCode} from "../lib/api/code";
import {getMainInfo, saveMainInfo} from "../lib/api/survey";
import LoadingPop from "../components/common/LoadingPop";
import client from "../lib/api/client";
import { numberToKorean } from '../utils/numberTokorean'
import { formatWithComma } from '../utils/utils'

const useStyles = makeStyles(theme => ({
    container: {
        width: '100%',
    },
    media: {
        height: 140,
        width: 125,
    },
    table: {
        minWidth: 600,
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 28px',
        height: 35,
        fontSize: "14px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    },
    backButton: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "white",
        padding: '5px 28px',
        height: 35,
        fontSize: "14px",
        color: 'black',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    },
    accorContainer: {
        marginBottom: 5
    },

    title: {
        paddingLeft: 35,
        fontSize: 13,
        color: "#1B6916"
    },
    fileSection: {
      marginTop: 12,
    },

    fileSectionTitle: {
      fontSize: 16,
      fontWeight: 700,
      marginBottom: 10,
    },

    fileGroup: {
      padding: '10px 0',
      borderTop: '1px solid #eee',
    },

    fileGroupTitle: {
      fontSize: 13,
      fontWeight: 700,
      color: '#333',
      marginBottom: 6,
    },

    fileList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
    },

    fileItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 8,
      paddingLeft: 12,
    },

    fileBullet: {
      lineHeight: '20px',
      color: '#666',
      flex: '0 0 auto',
    },

    fileName: {
      fontSize: 13,
      color: '#111',
      lineHeight: '20px',
      wordBreak: 'break-word',   // 긴 파일명 줄바꿈
      flex: '1 1 auto',
    },
}));

const addComma = (num) => {
    const regexp = /\B(?=(\d{3})+(?!\d))/g;
    return num.toString().replace(regexp, ',');
};

const ResultForm = ({ history }) => {
    const userInfo = useRecoilValue(userState);
    const [family, setFamily] = useRecoilState(familyState);
    const rent = useRecoilValue(rentState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const [seq, setSeq] = useRecoilState(seqState);
    const agree = useRecoilValue(agreeDataState);
    const survey = useRecoilValue(surveyDataState);
    const rentFiles = useRecoilValue(rentFileState);
    const etcReturnFiles = useRecoilValue(etcReturnFileState);
    const simpleFiles = useRecoilValue(simpleFileState);
    const [natCodeList, setNatCodeList] = useState([]);
    const [bankCodeList, setBankCodeList] = useState([]);
    const [famyRltCodeList, setFamyRltCodeList] = useState([]);
    const classes = useStyles();
    const [svrSurvey, setSvrSurvey] = useState({});
    const [svrHouse, setSvrHouse] = useState([]);
    const [svrCommercial, setSvrCommercial] = useState([]);
    const [disable, setDisable] = useState(false);
    const intFiles = useRecoilValue(intFileState);
    const bizFiles = useRecoilValue(bizFileState);

    const getCommCodeList = async (gropCd, setter) => {
        const { data } = await getCommCode(gropCd)
        setter(data.payload);
    };

    const getKognrMainInfo = async () => {
        const { data } = await getMainInfo(userInfo.corprInfoDiviNo, userInfo.stdYear, userInfo.admnNo)
        return data.payload;
    };

    const saveKognrMainInfo = async (obj) => {
        const { data } = await saveMainInfo(obj)
        if (data.success) {
            return data.payload;
        }
        return "";
    };

    const fetchCommCode = async () => {
        await getCommCodeList("CO034", setNatCodeList);
        await getCommCodeList("HC028", setBankCodeList);
        await getCommCodeList("YA011", setFamyRltCodeList);
    }

    useEffect(() => {
        // window.localStorage.setItem("previousLocation", window.location.pathname);
        // fetchCommCode()
        setAnswer(changeResultData(answer));
        if (userInfo.surveyYn === "1") {
            getKognrMainInfo().then((res) => {
                const { survey, family, rent } = res;

                if (survey.kognrSeq !== "") {
                    setAnswer({
                        ...survey,
                        requiredAgreeYn: "1"
                    });

                    setFamily(family ? family : []);
                    setSvrHouse(rent.filter((item) => (item["kognrRentCd"] === "HC051001")));
                    setSvrCommercial(rent.filter((item) => (item["kognrRentCd"] === "HC051002")));
                }
            })

        } else {
            setSvrSurvey(answer);
            // setSvrFamily(family);
        }

        let isMounted = true;

        // const fetchCommCode = async () => {
        //     try {
        //         const natCodeList = await getCommCodeList("CO034");
        //         const bankCdList = await getCommCodeList("HC028");
        //         const rltGcdList = await getCommCodeList("YA011");
        //
        //         if (isMounted) {
        //             setNatCodeList(natCodeList);
        //             setBankCodeList(bankCdList);
        //             setFamyRltCodeList(rltGcdList);
        //         }
        //     } catch (error) {
        //         // handle error
        //     }
        // };

        fetchCommCode();

        return () => {
            // Cleanup function to set isMounted to false when component is unmounted
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        if (rent) {
            setSvrHouse(Object.keys(rent.house).map((item) => (rent.house[item])));
            setSvrCommercial(Object.keys(rent.commercial).map((item) => (rent.commercial[item])));
        }
    }, [rent]);

    useEffect(() => {
        if (seq !== "" && seq !== undefined && seq !== null) {
            client.post('/kognr/logout').then(response => {
                if (response.data.success) {
                    localStorage.clear();
                    history.replace("/");
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [seq]);

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: "#ebeded",
            // color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);


    const sentences = [
        '안녕하세요. ' + answer.userNm + ' 주재원님,',
        userInfo.stdYear + '년도 귀속 세무 질문지를 작성해 주셔서 감사합니다.',
        '종합소득세 신고와 관련하여 문의사항이 있으신 경우 <span style=\'font-weight: bold\'>1:1문의</span> 게시판을 이용해 주십시오.'
    ];

    const getCodeName = (column, value) => {
        if(column === 'frorAgreeYn') {
            if ('0' === value) {
                return '예';
            } else if ('1' === value) {
                return '아니오';
            }
        }
        if (column === 'natlGcd' || column === 'dsptNatGcd') {
            for (let nat of natCodeList) {
                if (nat.commDetlsCd === value) {
                    return nat.detlsCdNm;
                }
            }
        } else if (column === 'rtnBankGcd') {
            for (let bank of bankCodeList) {
                if (bank.commDetlsCd === value) {
                    return bank.detlsCdNm;
                }
            }
        } else if (column === 'famyRltGcd') {
            for (let rltGcd of famyRltCodeList) {
                if (rltGcd.commDetlsCd === value) {
                    return rltGcd.detlsCdNm;
                }
            }
        } else if (column === 'frorRlspGcd') {
            if (value === 'HC035001') {
                return 'Self';
            } else if (value === 'HC035002') {
                return 'Spouse / Spouse Equivalent';
            } else if (value === 'HC035003') {
                return 'Dependent';
            }
        } else if (column === 'ssnNo') {
            if (value.length === 13) {
                value = value.substring(0, 6) + '-' + value.substring(6, 13);
                return value;
            }
        } else if (column === 'rentFileUpload') {
            if (rentFiles && rentFiles.length > 0) {
                return "첨부";
            }
            return "미첨부";
        } else if (column === 'etcFileUpload') {
            if (etcReturnFiles && etcReturnFiles.length > 0) {
                return "첨부";
            }
            return "미첨부";
        }

        if (column === "frorAgreeYn" || column === "familyAplyYn" || column === "intDiviYn" || column === "intYn" || column === "rentYn"
            || column === "optRentYn" || column === "bizYn" || column === "etcYn" || column === "famyObsYn" || column === "famyCareYn"
            || column === "taxAccntYn" || column === "jointYn" || column === "bizRegYn" || column === "rentBizYn" || column === "householderYn"
            || column === "divorceYn" || column === "marTaxYn") {
            if ('1' === value) {
                return '예';
            } else if ('0' === value) {
                return '아니오';
            }
        }

        if ((column !== 'rtnBankGcd' && column !== 'accNo' && column !== 'fileUrl') && (null === value || '' === value || undefined === value)) {
            return '해당 없음';
        } else if (column === "preBizAmt" || column === "preBizAmt_01" || column === "preBizAmt_02" || column === "preBizAmt_03" || column === "midPrepAmt"
                || column === "step_74") {
            // return addComma(value);
          return (
            <>
              {addComma(String(value).replace(/[^0-9]/g, ''))}
              {String(value).replace(/[^0-9]/g, '') && (
                <span style={{
                  marginLeft: 6,
                  color: '#666',
                  fontSize: 12
                }}>
                {numberToKorean(String(value).replace(/[^0-9]/g, ''))}
              </span>
              )}
            </>
          )
        } else if (column === "fileUrl" || column === "filUrl" || column === "rentFileUpload") {
            if (simpleFiles && simpleFiles.length > 0) {
                return "첨부";
            }
            return "미첨부";
        } else if (column === "divorceDt" && value === '') {
            return "해당 없음"
        }else
        {
            return value;
        }

    }

    const handleSaveButtonClick = () => {
        setDisable(true);

        // 부양가족 정보 저장
        let familyList = [];
        const regex = /[^0-9]/g;

        if (answer.familyAplyYn === '1') {
            let i = 1;
            for (const f of family) {
                const fam = {
                    ...f,
                    kognrFmifSeq: i,
                  famyIncomeAmt: typeof f.famyIncomeAmt === 'string'
                    ? Number(f.famyIncomeAmt.replace(regex, ""))
                    : Number(f.famyIncomeAmt) || 0  // undefined나 NaN인 경우 0으로 처리
                }
                familyList.push(fam);
                i++;
            }
        }

        const rentlist = [];
        if (answer.rentYn === "1") {
            for(let key in rent.house) {
                let rentPeriods = "";
                if (rent.house[key].rentPeriods && rent.house[key].rentPeriods.length > 0) {
                    rentPeriods = rent.house[key].rentPeriods.map(period =>
                        `${period.startDate} ~ ${period.endDate} ${period.rentDepositAmt}원`
                    ).join(" || ");
                }
                const tmpHouse = {
                    ...rent.house[key],
                    kognrRentCd: "HC051001",
                    rentIncomeAmt: Number(rent.house[key].rentIncomeAmt.replace(/[^0-9]/g, '')),
                    rentDepositAmt: Number(rent.house[key].rentDepositAmt.replace(/[^0-9]/g, '')),
                    stdMktAmt: Number(rent.house[key].stdMktAmt.replace(/[^0-9]/g, '')),
                    ddcArea: Number(rent.house[key].ddcArea.replace(/[^0-9.]/g, '')),
                    rentPeriods: rentPeriods,
                    jointYn: rent.house[key].jointYn || "0",
                    bizRegYn: rent.house[key].bizRegYn || "0",
                    rentBizYn: rent.house[key].rentBizYn || "0",
                    taxAccntYn: rent.house[key].taxAccntYn || "0",
                    taxAccntNm: rent.house[key].houseRentYn === "1" ? (rent.house[key].taxAccntNm || "") : "임대하지 않음"
                };
                // console.log(rent.house[key], tmpHouse);

                rentlist.push(tmpHouse);
            }

            for(let key in rent.commercial) {
              let rentPeriods = "";
              if (rent.commercial[key].rentPeriods && rent.commercial[key].rentPeriods.length > 0) {
                rentPeriods = rent.commercial[key].rentPeriods.map(period =>
                  `${period.startDate} ~ ${period.endDate} ${period.rentDepositAmt}원`
                ).join(" || ");
              }
                const tmpCommercial = {
                    ...rent.commercial[key],
                    kognrRentCd: "HC051002",
                    rentIncomeAmt: Number(rent.commercial[key].rentIncomeAmt.replace(/[^0-9]/g, '')),
                    rentDepositAmt: Number(rent.commercial[key].rentDepositAmt.replace(/[^0-9]/g, '')),
                    stdMktAmt: rent.commercial[key].stdMktAmt ? Number(rent.commercial[key].stdMktAmt.replace(/[^0-9]/g, '')) : 0,
                    ddcArea: 0,
                    rentPeriods: rentPeriods,
                    jointYn: rent.commercial[key].jointYn || "0",
                    bizRegYn: rent.commercial[key].bizRegYn || "0",
                    rentBizYn: rent.commercial[key].rentBizYn || "0",
                };
                // console.log(rent.commercial[key], tmpCommercial);
                rentlist.push(tmpCommercial);
            }
        }
        let result = {
            survey: {
                ...answer,
                admnNo: userInfo.admnNo,
                stdYear: userInfo.stdYear,
                corprInfoDiviNo: userInfo.corprInfoDiviNo,
                mailSendYn: "0",
                divorceDt: answer.divorceDt ? answer.divorceDt.replace(/[^0-9]/g, "") : "",
                divorceYn: answer.divorceYn ? answer.divorceYn : "0",
                marTaxYn: (answer.divorceYn === "1" || answer.marTaxYn === "1") ? "1" : "0",
                dsptSttDt: answer.dsptSttDt ? answer.dsptSttDt.replace(/[^0-9]/g, "") : "",
                dsptEndDt: answer.dsptEndDt ? answer.dsptEndDt.replace(/[^0-9]/g, "") : "",
                houseCnt: Number(answer.houseCnt ? answer.houseCnt.replace(/[^0-9]/g, '') : "0"),
                storeCnt: Number(answer.storeCnt ? answer.storeCnt.replace(/[^0-9]/g, '') : "0"),
                rentAmt: answer.rentAmt ? answer.rentAmt.replace(/[^0-9]/g, '') : 0,
                preBizAmt: Number(answer.preBizAmt ? answer.preBizAmt.replace(/[^0-9]/g, '') : "0"),
                preBizAmt_01: Number(answer.preBizAmt_01 ? answer.preBizAmt_01.replace(/[^0-9]/g, '') : "0"),
                preBizAmt_02: Number(answer.preBizAmt_02 ? answer.preBizAmt_02.replace(/[^0-9]/g, '') : "0"),
                preBizAmt_03: Number(answer.preBizAmt_03 ? answer.preBizAmt_03.replace(/[^0-9]/g, '') : "0"),
                midPrepAmt: Number(answer.midPrepAmt ? answer.midPrepAmt.replace(/[^0-9]/g, '') : "0"),
            },
            family: familyList,
            rent: rentlist,
        };

        // console.log(result);

        // console.log("최종 결과 : ", result);
        saveKognrMainInfo(result).then((res, err) => {
            if (res !== "") {
                history.replace("/thanks");
                setSeq(res.kognrSeq);
            }
            setDisable(false);
        });
    };

    const changeResultData = (answer) => {
        const survey = {...answer};
        if (survey.frorAgreeYn === "1") {
            survey.frorIndividual = undefined;
            survey.frorRlspGcd = undefined;
            survey.frorJobTitle = undefined;
            survey.frorCorpNm = undefined;
            survey.frorIndividual = undefined;
        }
        if (survey.spouse === "미혼" || survey.spouse === "기혼") {
            survey.divorceDt = undefined;
        }
        if (survey.rentYn === "0") {
            survey.houseCnt = undefined;
            survey.storeCnt = undefined;
            survey.preBizAmt = undefined;
            survey.preBizAmt_01 = undefined;
            survey.preBizAmt_02 = undefined;
            survey.preBizAmt_03 = undefined;
            survey.midPrepAmt = undefined;
            survey.optRentYn = undefined;
        }
        if (survey.step_32 === "1"){
            survey.step_33 = undefined;
            survey.step_34 = undefined;
        }
        if(survey.step_33 === "1"){
            survey.step_34 = undefined;
        }
        if(survey.step_41 !== "국내 대출기관"){
            survey.step_42 = undefined;
            survey.step_43 = undefined;
        }
        if(survey.step_41 !== "대부업 등을 경영하지 아니하는 거주자"){
            survey.step_44 = undefined;
            survey.step_45 = undefined;
        }
        if(survey.step_46 === "0"){
            survey.step_47 = undefined;
        }
        if(survey.step_47 === "1"){
            survey.step_48 = undefined
            survey.step_49 = undefined
            survey.step_50 = undefined
            survey.step_51 = undefined
            survey.step_52 = undefined
            survey.step_53 = undefined
            survey.step_54 = undefined
            survey.step_55 = undefined
            survey.step_56 = undefined
            survey.step_57 = undefined
            survey.step_58 = undefined
            survey.step_59 = undefined
        }
        if(survey.step_61 === "1"){
            survey.step_62 = undefined
            survey.step_63 = undefined
        }
        if(survey.step_62 === "1"){
            survey.step_63 = undefined
        }
        if(survey.step_72 === "0"){
            survey.step_73 = undefined
            survey.step_74 = undefined
        }
        if(survey.step_73 === "0"){
            survey.step_74 = undefined
        }
        if(survey.step_102 === "1"){
            survey.step_103 = undefined
            survey.step_104 = undefined
        }
        if(survey.step_103 === "1"){
            survey.step_104 = undefined
        }
        return survey;
    }

    const handleBackButtonClick = () => {
        history.push("/survey");
    }

    window.scrollTo(0, 0);

    const getDeductionInfoElement = () => {
        let deuctionInfoElement = [];

        deuctionInfoElement.push(getHtmlList(31, 32, 48));
        if (answer["step_46"] == "1" && answer["step_47"] == "0"){
            deuctionInfoElement.push(
                <TableRow key={'result_survey_'}>
                    <TableCell component="th" scope="row">
                        <Chip variant="outlined" label={'다른 임차주택에 대한 주택임차차입금 관련 사항'} />
                    </TableCell>
                    <TableCell/>
                </TableRow>
            )
            deuctionInfoElement.push(getHtmlList(-1, 50, 59));
        }
        deuctionInfoElement.push(getHtmlList(60, 61, 74));
        deuctionInfoElement.push(getHtmlList(75, 76, 80));
        deuctionInfoElement.push(getHtmlList(81, 82, 85));
        if (answer['step_81'] === '1' && answer['step_83'] === '0') {
            deuctionInfoElement.push(
                <TableRow key={'result_survey_127'}>
                    <TableCell component="th" scope="row">
                        <span className={classes.title}>- {survey[127].mailColumnNm}</span>
                    </TableCell>
                    <TableCell>
                        {getAnswerLabel(answer['step_127'])}
                    </TableCell>
                </TableRow>
            );
        }
        deuctionInfoElement.push(getHtmlList(86, 0, 0));
        deuctionInfoElement.push(getHtmlList(87, 88, 94));
        deuctionInfoElement.push(getHtmlList(95, 96, 100));
        deuctionInfoElement.push(getHtmlList(101, 102, 110));

        return deuctionInfoElement;
    };

    const getHtmlList = (parentStep, startStep, endStep) => {
        const htmlList = [];
        // 공제 정보 최상위 질문
        if(parentStep !== -1){
            htmlList.push(
                <TableRow key={'result_survey_' + survey[parentStep].step}>
                    <TableCell component="th" scope="row">
                        <Chip variant="outlined" label={survey[parentStep].mailColumnNm} />
                    </TableCell>
                    <TableCell>
                        {getAnswerLabel(answer[`step_${parentStep}`])}
                    </TableCell>
                </TableRow>
            )
        }
        // 공제 겅보 하위 질문
        if(answer[`step_${parentStep}`] === "1" || parentStep === -1){ // 상위 공제 조건 질문 답변이 "예"인 경우만 하위 답변 렌더
            for(let i = startStep; i <= endStep; i++){
                const row = survey[i];
                if (row.type !== 'title' && row?.hasOwnProperty('mailColumnNm')) {
                    htmlList.push(
                        <TableRow key={'result_survey_' + row.step}>
                            <TableCell component="th" scope="row">
                                <span className={classes.title}>- {row.mailColumnNm}</span>
                            </TableCell>
                            <TableCell>
                                {i === 74 ? getCodeName(row.column, answer[row.column]) : getAnswerLabel(answer[`step_${row.step}`])}
                            </TableCell>
                        </TableRow>
                    )
                    if(i === 61){
                        htmlList.push(
                            <TableRow key={'result_survey_126'}>
                                <TableCell component="th" scope="row">
                                    <span className={classes.title}>- {survey[126].mailColumnNm}</span>
                                </TableCell>
                                <TableCell>
                                    {getAnswerLabel(answer['step_126'])}
                                </TableCell>
                            </TableRow>
                        )
                    }
                    if(i === 80){
                        htmlList.push(
                            <TableRow key={'result_survey_' + 119}>
                                <TableCell component="th" scope="row">
                                    <span className={classes.title}>- {survey[119].mailColumnNm}</span>
                                </TableCell>
                                <TableCell>
                                    {getAnswerLabel(answer[`step_${119}`])}
                                </TableCell>
                            </TableRow>
                        )
                    }
                }
            }
        }
        return htmlList;
    }

    const getAnswerLabel = (answer) => {
        if(answer === "1") return "예";
        if(answer === "0") return "아니오";
        if(answer === undefined ) return "해당 없음";
        return answer;
    }

    return (userInfo && natCodeList.length > 0) && (
        <Grid container
              direction="column"
              alignItems="center"
              justifyContent="center"
        >
            <div className={classes.container}>
                <CardMedia
                    className={classes.media}
                    image={logoImg}
                />
                <br/>
                <SentenceForm
                    sentences={sentences} isResult={true}
                />
                <br/>
                <Typography variant="h6">
                    <Box fontWeight="fontWeightBold">
                        ▶ 질문지 답변 내역
                    </Box>
                </Typography>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell key={"column-header"}>항목</StyledTableCell>
                            <StyledTableCell key={"answer-header"}>답변</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {agree && agree.map(row => {
                            if (row.column === 'familyAplyYn') {
                                // TODO replace 때문에 주석
                                // row.title = '가족정보 반영 여부';
                            } else if (row.column === 'requiredAgreeYn') {
                                // setAnswer({
                                //     ...answer,
                                //     [row.column]: "1"
                                // });
                            }

                            return (
                                <TableRow key={'result_agree_' + row.step}>
                                    <TableCell component="th" scope="row">
                                        <Chip variant="outlined" label={row.title.replace('$stdYear$', userInfo.stdYear)} />
                                    </TableCell>
                                    <TableCell>{answer[row.column] === '1' ? '동의' : '비동의'}</TableCell>
                                </TableRow>
                            )
                        })}
                        {survey && survey.map((row, idx) => {
                            if (row.column === 'familyAplyYn') {
                                // TODO replace 때문에 주석
                                // row.title = '가족정보 반영 여부';
                            }
                            if(row.step === 9){
                                return (
                                    <>
                                        <TableRow key={'result_survey_118'}>
                                            <TableCell component="th" scope="row">
                                                <Chip variant="outlined" label={"1 - 3) 주소"}/>
                                            </TableCell>
                                            <TableCell>{answer['roadAddr']} {answer['roadAddrDetail']}</TableCell>
                                        </TableRow>
                                        <TableRow key={'result_survey_' + row.step}>
                                            <TableCell component="th" scope="row">
                                                <Chip variant="outlined" label={"1 - 4) 배우자 유무"}/>
                                            </TableCell>
                                            <TableCell>{answer[row.column]}</TableCell>
                                        </TableRow>
                                        {(answer["spouse"] === "사별" || answer["spouse"] === "이혼") &&
                                          (
                                            <>
                                              <TableRow key={'result_survey_116'}>
                                                <TableCell component="th" scope="row">
                                                  <span
                                                    className={classes.title}>- 사별/이혼한 날짜 </span>
                                                </TableCell>
                                                <TableCell>{getCodeName('divorceDt', answer['divorceDt'])}</TableCell>
                                              </TableRow>
                                              {/*<TableRow key={'120'}>*/}
                                              {/*  <TableCell component="th" scope="row">*/}
                                              {/*    <span*/}
                                              {/*      className={classes.title}>- 혼인유지여부 </span>*/}
                                              {/*  </TableCell>*/}
                                              {/*  <TableCell>{getCodeName('divorceYn', answer['divorceYn'])}</TableCell>*/}
                                              {/*</TableRow>*/}
                                            </>
                                          )
                                        }
                                      {answer["spouse"] === "기혼" &&
                                        (
                                          <>
                                            <TableRow key={'125'}>
                                              <TableCell component="th" scope="row">
                                                  <span
                                                    className={classes.title}>- 결혼세액공제여부 </span>
                                              </TableCell>
                                              <TableCell>{getCodeName('marTaxYn', answer['marTaxYn'])}</TableCell>
                                            </TableRow>
                                          </>
                                        )
                                      }
                                        <TableRow key={'result_survey_117'}>
                                            <TableCell component="th" scope="row">
                                                <Chip variant="outlined" label={"1 - 5) 세대주 여부"}/>
                                            </TableCell>
                                            <TableCell>{getCodeName('householderYn', answer['householderYn'])}</TableCell>
                                        </TableRow>
                                    </>
                                )
                            }

                            if((row.step > 29 && row.step <= 110) || (row.step >= 116 && row.step < 121) || row.step > 124) return null;
                            if([1, 2, 3, 4].includes(row.step) && answer["frorAgreeYn"] === "1" ) return null;


                            if ([20,21,25,26,27].includes(row.step)) {
                                return (
                                    <>
                                        <TableRow key={`result_survey_` + row.step}>
                                            <TableCell component="th" scope="row" >
                                                {row.treeTitle.includes(")") || row.step === 0 ?
                                                    <Chip variant="outlined" label={row.treeTitle.replace('$stdYear$', userInfo.stdYear)} />
                                                    : <span className={classes.title}>- {row.treeTitle.replace('$stdYear$', userInfo.stdYear)}</span>
                                                }
                                            </TableCell>
                                            <TableCell>{row.column === "houseCnt" ? `주택: ${answer["houseCnt"] || 0}, 상가: ${answer["storeCnt"] || 0}` : getCodeName(row.column, answer[row.column])}</TableCell>
                                        </TableRow>
                                        {row.step === 27 && survey
                                            .filter(item => [121, 122, 123, 124].includes(item.step))
                                            .map(item => (
                                                <TableRow key={`result_survey_` + item.step}>
                                                    <TableCell component="th" scope="row" >
                                                        {item.treeTitle.includes(")") || item.step === 0 ?
                                                            <Chip variant="outlined" label={item.treeTitle.replace('$stdYear$', userInfo.stdYear)} />
                                                            : <span className={classes.title}>- {item.treeTitle.replace('$stdYear$', userInfo.stdYear)}</span>
                                                        }
                                                    </TableCell>
                                                    <TableCell>{getCodeName(item.column, answer[item.column])}</TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </>
                                )
                            }

                            if (row.type !== 'title' && row.step !== 7 && row.step !== 16 && row.step !== 20 && row.step !== 21 && row.step !== 24 && row.step !== 25 && row.step !== 26 && row.step !== 27 && row.step !== 22 && row.step !== 23
                              && row.step !== 121 && row.step !== 122 && row.step !== 123 && row.step !== 124) {
                                return (
                                    <>
                                        <TableRow key={'result_survey_' + row.step}>
                                            <TableCell component="th" scope="row" >
                                                {row.treeTitle.includes(")") || row.step === 0 ?
                                                    <Chip variant="outlined" label={row.treeTitle.replace('$stdYear$', userInfo.stdYear)} />
                                                    : <span className={classes.title}>- {row.treeTitle.replace('$stdYear$', userInfo.stdYear)} - {row.step}</span>
                                                }
                                            </TableCell>
                                            {/*<TableCell>{row.column === "houseCnt" ? `주택: ${answer["houseCnt"] || 0}, 상가: ${answer["storeCnt"] || 0}` : getCodeName(row.column, answer[row.column])}</TableCell>*/}
                                          <TableCell>{
                                            getCodeName(row.column, answer[row.column])
                                          }</TableCell>
                                        </TableRow>
                                        {row.step === 29 && getDeductionInfoElement()}
                                    </>
                                )
                            }
                            return null;
                        })}
                    </TableBody>
                </Table>
                <br/>
                <Typography variant="h6">
                    <Box fontWeight="fontWeightBold">
                        ▶ 가족정보
                    </Box>
                </Typography>
                <Divider variant="middle" />
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>성명</TableCell>
                            <TableCell>주민등록번호</TableCell>
                            <TableCell>가족관계</TableCell>
                            <TableCell>소득금액</TableCell>
                            <TableCell>부양여부</TableCell>
                            <TableCell>장애여부</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {answer.familyAplyYn === "0" && (
                            <TableRow>
                                <TableCell colSpan={6} align={'center'}>
                                    2025년도 귀속 연말정산을 진행하였고, 연말정산의 부양가족 정보로 동일하게 반영
                                </TableCell>
                            </TableRow>
                        )}
                        {(answer.familyAplyYn === "1" && answer.onePersonHouseholdYn === "1" && family.length === 0)&& (
                            <TableRow>
                                <TableCell colSpan={6} align={'center'}>
                                    입력된 가족 정보가 없습니다.
                                </TableCell>
                            </TableRow>
                        )}
                        {family.length > 0 && family.map(row => {

                            return (
                                <TableRow key={'result_family_' + row['kognrFmifSeq']}>
                                    <TableCell component="th" scope="row">
                                        {row['famyNm']}
                                    </TableCell>
                                    <TableCell>{row["famySsnNo"].substring(0, 6) + '-' + row["famySsnNo"].substring(6, 13)}</TableCell>
                                    <TableCell>{getCodeName("famyRltGcd", row.famyRltGcd)}</TableCell>
                                    <TableCell>{addComma(row['famyIncomeAmt'])}</TableCell>
                                    <TableCell>{row['famyCareYn'] === '1' ? '예' : '아니오'}</TableCell>
                                    <TableCell>{row['famyObsYn'] === '1' ? '예' : '아니오'}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>

                <br/>
                <Typography variant="h6">
                    <Box fontWeight="fontWeightBold">
                        ▶ 임대정보
                    </Box>
                </Typography>
                <Divider variant="middle" />
                {svrHouse.map((item, index) => (
                    <div className={classes.accorContainer}>
                        <HouseSummaryAccordion houseNo={index + 1} data={item} />
                    </div>
                ))}
                {svrCommercial.map((item, index) => (
                    <div className={classes.accorContainer}>
                        <CommercialSummaryAccordion commercialNo={index + 1} data={item} />
                    </div>
                ))}
              <br/>
              <div className={classes.fileSection}>
                <div className={classes.fileSectionTitle}>▶ 첨부파일 내역</div>
                {/*{intFiles.length > 0 && (*/}
                {/*  <>*/}
                {/*    <h5 className={classes.subtitle}>국외금융기관으로부터 수령한 이자, 배당소득 첨부파일</h5>*/}
                {/*    {intFiles.map((item, index) => (*/}
                {/*      <div key={index} className={classes.accorContainer}>*/}
                {/*        <h6>{item.fileNm} aa</h6>*/}
                {/*      </div>*/}
                {/*    ))}*/}
                {/*  </>*/}
                {/*)}*/}
                {intFiles?.length > 0 && (
                  <div className={classes.fileGroup}>
                    <div className={classes.fileGroupTitle}>국외금융기관으로부터 수령한 이자, 배당소득 첨부파일</div>
                    <div className={classes.fileList}>
                      {intFiles.map((item, index) => (
                        <div key={item?.fileNm ?? index} className={classes.fileItem}>
                          <span className={classes.fileBullet}>•</span>
                          <span className={classes.fileName}>{item.fileNm}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {bizFiles?.length > 0 && (
                  <div className={classes.fileGroup}>
                    <div className={classes.fileGroupTitle}>사업소득 첨부파일</div>
                    <div className={classes.fileList}>
                      {bizFiles.map((item, index) => (
                        <div key={item?.fileNm ?? index} className={classes.fileItem}>
                          <span className={classes.fileBullet}>•</span>
                          <span className={classes.fileName}>{item.fileNm}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {rentFiles?.length > 0 && (
                  <div className={classes.fileGroup}>
                    <div className={classes.fileGroupTitle}>임대소득관련 첨부파일</div>
                    <div className={classes.fileList}>
                      {rentFiles.map((item, index) => (
                        <div key={item?.fileNm ?? index} className={classes.fileItem}>
                          <span className={classes.fileBullet}>•</span>
                          <span className={classes.fileName}>{item.fileNm}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {simpleFiles?.length > 0 && (
                  <div className={classes.fileGroup}>
                    <div className={classes.fileGroupTitle}>간소화자료 첨부파일</div>
                    <div className={classes.fileList}>
                      {simpleFiles.map((item, index) => (
                        <div key={item?.fileNm ?? index} className={classes.fileItem}>
                          <span className={classes.fileBullet}>•</span>
                          <span className={classes.fileName}>{item.fileNm}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {etcReturnFiles?.length > 0 && (
                  <div className={classes.fileGroup}>
                    <div className={classes.fileGroupTitle}>기타 공제자료 첨부파일</div>
                    <div className={classes.fileList}>
                      {etcReturnFiles.map((item, index) => (
                        <div key={item?.fileNm ?? index} className={classes.fileItem}>
                          <span className={classes.fileBullet}>•</span>
                          <span className={classes.fileName}>{item.fileNm}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {userInfo.surveyYn !== '1'  && (
                <Grid container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                >
                    <div>
                        <Button
                            variant="outlined"
                            className={classes.backButton}
                            id='back'
                            name='back'
                            value='back'
                            // disabled={file.isProcess || isCompleteSave || !isValid}
                            onClick={handleBackButtonClick}
                        >
                            뒤로가기
                        </Button>
                        <Button
                            variant="contained"
                            className={classes.button}
                            id='next'
                            name='next'
                            value='next'
                            disabled={disable}
                            onClick={handleSaveButtonClick}
                        >
                            최종 제출하기
                        </Button>

                    </div>
                </Grid>
            )}
            {disable && <LoadingPop/>}
        </Grid>
    );
};

export default withRouter(ResultForm);

